import apiClient from './apiClient';

export interface P5M3Candidate {
  fp230_01: string;
  fp230_11: string | null;
  fp230_13: string;
  fp230_14: string;
  fp230_16: string;
  fp230_18: string;
  fp230_80: string;
}

export interface P5M3QueryResponse {
  items: P5M3Candidate[];
  total: number;
}

export interface P5M3ReverseResponse {
  success: number;
  message: string;
}

export const p5m3Api = {
  async query(start: string, end: string): Promise<P5M3QueryResponse> {
    const response = await apiClient.get('/api/p5m3/candidates', {
      params: { start, end },
    });
    return response.data;
  },

  async reverse(reportNos: string[]): Promise<P5M3ReverseResponse> {
    const response = await apiClient.post('/api/p5m3/reverse', {
      confirmed: true,
      items: reportNos.map((no) => ({ no, checked: true })),
    });
    return response.data;
  },
};
